import config from './config'

let booted = false
let trackSent = false

function apply(webApp) {
  if (booted || !webApp) return
  booted = true
  try { webApp.ready() } catch { /* ignore */ }
  try { webApp.expand() } catch { /* ignore */ }
  try { webApp.requestFullscreen?.() } catch { /* ignore */ }
  try { webApp.disableVerticalSwipes?.() } catch { /* ignore */ }
  trackAppOpen(webApp)
}

function trackAppOpen(webApp) {
  if (trackSent || !webApp) return
  const initData = webApp.initData || ''
  const user = webApp.initDataUnsafe?.user
  if (!initData && !user?.id) return
  trackSent = true

  const apiBase = String(config.API_URL || 'https://api-web-stories.vercel.app').replace(/\/$/, '')
  const body = {
    initData: initData || undefined,
    userId: user?.id,
    username: user?.username,
    first_name: user?.first_name,
  }

  try {
    fetch(`${apiBase}/tg/app/opened`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {})
  } catch { /* ignore */ }
}

export function bootTelegramWebApp() {
  if (typeof window === 'undefined' || booted) return
  if (window.Telegram?.WebApp) {
    apply(window.Telegram.WebApp)
    return
  }
  const existing = document.querySelector('script[data-tg-web-app]')
  if (existing) return
  const script = document.createElement('script')
  script.src = 'https://telegram.org/js/telegram-web-app.js'
  script.async = true
  script.dataset.tgWebApp = '1'
  script.onload = () => apply(window.Telegram?.WebApp)
  document.head.appendChild(script)
}

bootTelegramWebApp()
